import { render, staticRenderFns } from "./vipManagement.vue?vue&type=template&id=25668d8c&scoped=true&"
import script from "./vipManagement.vue?vue&type=script&lang=js&"
export * from "./vipManagement.vue?vue&type=script&lang=js&"
import style0 from "./vipManagement.vue?vue&type=style&index=0&id=25668d8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25668d8c",
  null
  
)

export default component.exports